function ChangeIllustration({ variant }) {
  if (variant === 'phone') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 50 50" fill="none" aria-hidden="true">
        <rect x="14" y="8" width="22" height="34" rx="3" stroke="rgba(129,174,228,0.5)" strokeWidth="1.5" />
        <circle cx="25" cy="37" r="2" fill="rgba(129,174,228,0.4)" />
        <path d="M20 12h10" stroke="rgba(129,174,228,0.35)" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    );
  }
  if (variant === 'email') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 50 50" fill="none" aria-hidden="true">
        <rect x="8" y="14" width="34" height="22" rx="3" stroke="rgba(129,174,228,0.5)" strokeWidth="1.5" />
        <path d="M8 17l17 12 17-12" stroke="rgba(129,174,228,0.4)" strokeWidth="1.5" strokeLinejoin="round" />
      </svg>
    );
  }
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 50 50" fill="none" aria-hidden="true">
      <rect x="14" y="20" width="22" height="16" rx="2" stroke="rgba(129,174,228,0.5)" strokeWidth="1.5" />
      <path d="M18 20v-4a7 7 0 0114 0v4" stroke="rgba(129,174,228,0.5)" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="25" cy="28" r="2" fill="rgba(129,174,228,0.4)" />
    </svg>
  );
}

function ChangeField({ label, type = 'text', value, onChange, autoComplete, inputMode, disabled }) {
  return (
    <div className="account-change-field">
      <div className="account-change-field__label">{label}</div>
      <div className="account-change-field__input-wrap">
        <div className="account-change-field__line">
          <div className="account-change-field__line-content">
            <input
              className="account-change-field__input"
              type={type}
              value={value}
              onChange={onChange}
              autoComplete={autoComplete}
              inputMode={inputMode}
              disabled={disabled}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export function ProfileChangeSupport({ variant, title, message, steps, actionLabel, onAction }) {
  const list = Array.isArray(steps) ? steps.filter(Boolean) : [];
  return (
    <form className="account-change-form" noValidate>
      <span className="account-change-form__art" aria-hidden="true">
        <ChangeIllustration variant={variant} />
      </span>
      <div className="account-change-form__content">
        <div className="account-change-form__controls account-change-form__controls--wide">
          <h2 className="account-change-form__heading">{title}</h2>
          {message ? <p className="account-change-form__message">{message}</p> : null}
          {list.length > 0 ? (
            <ol className="account-change-form__steps">
              {list.map((step, index) => (
                <li key={`${index}-${step}`} className="account-change-form__step">
                  <span className="account-change-form__step-num">{index + 1}</span>
                  <span className="account-change-form__step-text">{step}</span>
                </li>
              ))}
            </ol>
          ) : null}
          <div className="account-change-form__buttons">
            <button type="button" className="account-change-form__submit" onClick={onAction}>
              {actionLabel}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
}

export function ProfileChangeContact({
  variant,
  title,
  message,
  valueLabel,
  codeLabel,
  value,
  code,
  step,
  maskedContact,
  onValueChange,
  onCodeChange,
  onSendCode,
  onVerify,
  onBack,
  loading,
  resendDisabled = false,
  sendLabel,
  confirmLabel,
  resendLabel,
  backLabel,
  error,
  success,
}) {
  const isCodeStep = step === 'code';
  return (
    <form
      className="account-change-form"
      onSubmit={(e) => {
        e.preventDefault();
        if (isCodeStep) onVerify?.(e);
        else onSendCode?.(e);
      }}
      noValidate
    >
      <span className="account-change-form__art" aria-hidden="true">
        <ChangeIllustration variant={variant} />
      </span>
      <div className="account-change-form__content">
        <div className="account-change-form__controls account-change-form__controls--wide">
          <h2 className="account-change-form__heading">{title}</h2>
          {message ? (
            <p className="account-change-form__message">
              {message}
              {isCodeStep && maskedContact ? (
                <>
                  {' '}
                  <strong>{maskedContact}</strong>
                </>
              ) : null}
            </p>
          ) : null}
          {!isCodeStep ? (
            <ChangeField
              label={valueLabel}
              type={variant === 'email' ? 'email' : 'tel'}
              value={value}
              onChange={(e) => onValueChange?.(e.target.value)}
              autoComplete={variant === 'email' ? 'email' : 'tel'}
              inputMode={variant === 'email' ? 'email' : 'tel'}
              disabled={loading}
            />
          ) : (
            <ChangeField
              label={codeLabel}
              type="text"
              value={code}
              onChange={(e) => onCodeChange?.(e.target.value.replace(/\D/g, '').slice(0, 6))}
              autoComplete="one-time-code"
              inputMode="numeric"
              disabled={loading}
            />
          )}
          {error && <div className="account-change-form__error">{error}</div>}
          {success && <div className="account-change-form__success">{success}</div>}
          <div className="account-change-form__buttons">
            {isCodeStep ? (
              <>
                <button type="submit" className="account-change-form__submit" disabled={loading}>
                  {loading ? '...' : confirmLabel}
                </button>
                <button
                  type="button"
                  className="account-change-form__submit account-change-form__submit--secondary"
                  disabled={loading || resendDisabled}
                  onClick={onSendCode}
                >
                  {loading ? '...' : resendLabel}
                </button>
                <button
                  type="button"
                  className="account-change-form__submit account-change-form__submit--ghost"
                  disabled={loading}
                  onClick={onBack}
                >
                  {backLabel}
                </button>
              </>
            ) : (
              <button type="submit" className="account-change-form__submit" disabled={loading}>
                {loading ? '...' : sendLabel}
              </button>
            )}
          </div>
        </div>
      </div>
    </form>
  );
}

export function ProfileChangePassword({ title, labels, values, onChange, onSubmit, loading, submitLabel, error, success }) {
  return (
    <form className="account-change-form" onSubmit={onSubmit} noValidate>
      <span className="account-change-form__art" aria-hidden="true">
        <ChangeIllustration variant="password" />
      </span>
      <div className="account-change-form__content">
        <div className="account-change-form__controls">
          <ChangeField
            label={labels.current}
            type="password"
            value={values.current}
            onChange={(e) => onChange('current', e.target.value)}
            autoComplete="current-password"
          />
          <ChangeField
            label={labels.new}
            type="password"
            value={values.next}
            onChange={(e) => onChange('next', e.target.value)}
            autoComplete="new-password"
          />
          <ChangeField
            label={labels.confirm}
            type="password"
            value={values.confirm}
            onChange={(e) => onChange('confirm', e.target.value)}
            autoComplete="new-password"
          />
          {error && <div className="account-change-form__error">{error}</div>}
          {success && <div className="account-change-form__success">{success}</div>}
          <div className="account-change-form__buttons">
            <button type="submit" className="account-change-form__submit" disabled={loading}>
              {loading ? '...' : submitLabel}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
}
